import cx from 'classnames'
import React from 'react'

import * as styles from './icon-content-block.module.css'
import SVG from '@cinch/oxd-components/svg/src'
import { Text, TextStyles } from '@cinch-labs/design-system'
import { CarFront, Engine } from '@cinch/oxd-components/tech-specs-panel/src/icons'

import {
  CarCircle,
  Chassis,
  ChatCircle,
  Electric,
  Heart,
  StarCircle,
  MagnifierCircle,
  CleaningCircle,
  ArrowsCircle,
  SanitiserCircle,
  MaskCircle,
} from '@cinch/oxd-components/icons/src'
import SecondaryWrapper from '@cinch/oxd-components/button/src/secondary-wrapper/secondary-wrapper.component'

export interface ContentBlock {
  title: string
  body: React.ReactNode
  icon?: string
  styles?: any
  ctaText?: string
  ctaLink?: string
  ctaTag?: Cinch.AnalyticsTag
}

const icons = {
  default: null,
  arrows: ArrowsCircle,
  car: CarCircle,
  heart: Heart,
  engine: Engine,
  body: CarFront,
  chassis: Chassis,
  electrics: Electric,
  star: StarCircle,
  magnifier: MagnifierCircle,
  chat: ChatCircle,
  cleaning: CleaningCircle,
  sanitiser: SanitiserCircle,
  mask: MaskCircle,
}

const IconContentBlock: React.FC<ContentBlock> = ({ title, body, icon, ctaText, ctaLink, ctaTag }) => {
  return (
    <div key={title} className={styles.item}>
      <div className={styles.iconWrapper}>
        <SVG
          width={'100%'}
          height={'100%'}
          className={cx(styles.icon, styles[icon || 'default'])}
          children={icons[(icon as keyof typeof icons) || 'default']}
        />
      </div>

      <div className={styles.textWrapper}>
        <Text oxford={true} type={TextStyles.vehicleSubTitle} className={styles.title}>
          {title}
        </Text>
        <div className={styles.body}>{body}</div>
        {ctaText && ctaLink && (
          <SecondaryWrapper classNames={{ button: styles.cta }} element="a" href={ctaLink} tag={ctaTag}>
            {ctaText}
          </SecondaryWrapper>
        )}
      </div>
    </div>
  )
}

export default IconContentBlock
